import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import MenuManager from '@yooink/youtils/es/MenuManager';
import { Route, Switch } from 'react-router-dom';
import { useLoadComponent } from '@yooink/youtils/es/hooks/useLoadComponent';
import { BiWindow } from "react-icons/bi";
MenuManager.RegisterItem({
    parent: 'content',
    key: 'promoModals',
    path: '/promomodals',
    icon: _jsx(BiWindow, {}),
    position: 2,
    name: 'Промо-модали'
});
export function PromoModalsRoute(props) {
    const basePath = props.path || '/promomodals';
    const getPath = (path = '') => `${basePath}${path}`;
    const List = useLoadComponent(() => {
        // @ts-ignore
        return import('./List').then((res) => res.List);
    }, {
        basePath
    });
    const View = useLoadComponent(() => {
        // @ts-ignore
        return import('./EditPromoModal').then((res) => res.EditPromoModalPage);
    }, {
        basePath
    });
    return (_jsxs(_Fragment, { children: [_jsx(Route, { exact: true, path: getPath(), component: List }), _jsx(Switch, { children: _jsx(Route, { exact: true, path: getPath('/:id'), component: View }) })] }));
}
;
